import React from 'react';
import styled from 'styled-components/macro';
import { useJoinUrl } from 'src/client/components/buttons/JoinButton';
import { useSelector } from 'src/client/redux';
import { Site } from 'src/client/redux/modules/site';
import { DESKTOP, TABLET_PORTRAIT } from 'src/client/constants/mediaQueries';

type PromoCrossBannerImageProps = {
  desktopImage: string;
  mobileImage: string;
  tabletImage: string;
};

export type PromoCrossBannerProps = {
  promoSite: Site;
  promoGalleryUUID: string;
};

export const PromoCrossBanner = (props: PromoCrossBannerProps) => {
  const { cdnUrl } = useSelector((state) => state.app);
  const parentSite = useSelector((state) => state.site);
  const [joinHref] = useJoinUrl({
    campaign: `cross-promo-${parentSite.abbreviation}`,
    overrideSite: props.promoSite?.abbreviation,
    extraParams: {
      channel: `gallery-${props.promoGalleryUUID}`,
    },
  });

  const desktopImage = `${cdnUrl}/promoBanners/cross-promo/${props.promoSite?.abbreviation}_desktop.jpg`;
  const tabletImage = `${cdnUrl}/promoBanners/cross-promo/${props.promoSite?.abbreviation}_mobile_hor.jpg`;
  const mobileImage = `${cdnUrl}/promoBanners/cross-promo/${props.promoSite?.abbreviation}_mobile_ver.jpg`;

  return (
    <BannerWrapper>
      <BannerLink href={joinHref} desktopImage={desktopImage} mobileImage={mobileImage} tabletImage={tabletImage} />
    </BannerWrapper>
  );
};

const BannerWrapper = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
`;

const BannerLink = styled.a<PromoCrossBannerImageProps>`
  aspect-ratio: 300 / 80;
  background-image: url(${({ mobileImage }) => mobileImage});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  max-width: 300px;
  width: 100%;

  @media ${TABLET_PORTRAIT} {
    aspect-ratio: 720 / 130;
    background-image: url(${({ tabletImage }) => tabletImage});
    max-width: 720px;
  }

  @media ${DESKTOP} {
    aspect-ratio: 980 / 140;
    background-image: url(${({ desktopImage }) => desktopImage});
    max-width: 980px;
  }
`;
